import type { AbsoluteLocation, ZIndex, Sizes } from 'types/styles';

import styled from 'styled-components';

interface Props extends Sizes, AbsoluteLocation, ZIndex {}

export const RelativeWrapper = styled.div<Props>`
    position: relative;
    width: ${({ width }) => width || '100%'};
    height: ${({ height }) => height || '100%'};
    ${({ left }) => left && `left: ${left}`};
    ${({ right }) => right && `right: ${right}`};
    ${({ bottom }) => bottom && `bottom: ${bottom}`};
    ${({ top }) => top && `top: ${top}`};
    ${({ zIndex }) => zIndex && `z-index: ${zIndex};`};
`;
